import { DialogFooter, DialogHeader, DialogTitle } from '../../../../common/components/ui/dialog';
import { Button } from '../../../../common/components/ui/button';
import { useTranslation } from 'react-i18next';
import { useFetcher } from 'react-router';
import { useBasePath } from '../../../../common/hooks/useBasePath';

export function CartDialogOciSessionError() {
  const fetcher = useFetcher();
  const { t } = useTranslation();
  const { path: basePath } = useBasePath();

  return (
    <>
      <DialogHeader>
        <DialogTitle className={'flex items-center'}>{t('Der OCI Warenkorb ist verfallen')}</DialogTitle>
      </DialogHeader>
      <div>
        <p>{t('Bitte melden Sie sich über das Bestellsystem erneut an')}.</p>
      </div>
      <DialogFooter className={'flex-col desktop:flex-row gap-4 desktop:gap-1'}>
        <fetcher.Form method={'POST'} action={'/infra/auth/logout'}>
          <input type="hidden" name="redirectTo" value={basePath} />
          <Button type="submit" data-testid={'cart-logout-button'}>
            {t('OK')}!
          </Button>
        </fetcher.Form>
      </DialogFooter>
    </>
  );
}
